import request from '@/utils/request'

// 行业动态列表(首页无权限)
export function industryNoAuthList(query) {
    return request({
        url: '/methanol/industry/noAuth/boardList',
        method: 'get',
        params: query
    })
}

// 行业动态二级页
export function industryPage(query) {
    return request({
        url: `/methanol/industry/macroscopicList`,
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/methanol/industry/${id}`,
        method: 'get',
    })
}

// 价格列表(首页无权限)
export function methanolPriceNoAuthList(query) {
    return request({
        url: '/methanol/metatron/price/noAuth/priceList',
        method: 'get',
        params: query
    })
}

// 价格列表
export function pricePage(query) {
    return request({
        url: '/methanol/metatron/price/priceList',
        method: 'get',
        params: query
    })
}

// 价格详情
export function priceDetail(query) {
    return request({
        url: '/methanol/metatron/price/detailsPriceList',
        method: 'get',
        params: query
    })
}

// 下游产品价格列表(首页无权限)
export function productPriceNoAuthList(query) {
    return request({
        url: '/methanol/metatron/price/noAuth/producPricetList',
        method: 'get',
        params: query
    })
}

// 下游产品价格列表
export function productPricePage(query) {
    return request({
        url: '/methanol/metatron/price/producPricetList',
        method: 'get',
        params: query
    })
}

// 下游产品价格详情
export function productPriceDetail(query) {
    return request({
        url: '/methanol/metatron/price/detailsProducPricetList',
        method: 'get',
        params: query
    })
}

// 开工率列表(首页无权限)
export function rateNoAuthList(query) {
    return request({
        url: '/methanol/metatron/rate/noAuth/rateList',
        method: 'get',
        params: query
    })
}

// 开工率列表
export function ratePage(query) {
    return request({
        url: '/methanol/metatron/rate/rateList',
        method: 'get',
        params: query
    })
}

// 开工率详情
export function rateDetail(query) {
    return request({
        url: '/methanol/metatron/rate/detailsList',
        method: 'get',
        params: query
    })
}

// 研究报告和技术及标准(首页无权限)
export function noAuthReportAndStandard(query) {
    return request({
        url: `/methanol/report/noAuth/list`,
        method: 'get',
        params: query
    })
}

// 技术与标准列表
export function reportPage(query) {
    return request({
        url: `/methanol/report/reportList`,
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function methanolReportDetail(id) {
    return request({
        url: `/methanol/report/boardInfo/${id}`,
        method: 'get',
    })
}

// 技术与标准列表
export function standardPage(query) {
    return request({
        url: `/methanol/report/technicalList`,
        method: 'get',
        params: query
    })
}

// 技术与标准详情
export function standardDetail(id) {
    return request({
        url: `/methanol/report/technicalInfo/${id}`,
        method: 'get',
    })
}

// 产量列表(首页无权限)
export function methanolYieldNoAuthList(query) {
    return request({
        url: '/methanol/metatron/yield/noAuth/yieldList',
        method: 'get',
        params: query
    })
}

// 产量列表
export function yieldPage(query) {
    return request({
        url: '/methanol/metatron/yield/yieldList',
        method: 'get',
        params: query
    })
}

// 产量详情
export function yieldDetail(query) {
    return request({
        url: '/methanol/metatron/yield/detailsYieldList',
        method: 'get',
        params: query
    })
}

// 库存列表(首页无权限)
export function stockNoAuthList(query) {
    return request({
        url: '/methanol/metatron/stock/noAuth/stockList',
        method: 'get',
        params: query
    })
}

// 库存列表
export function stockPage(query) {
    return request({
        url: '/methanol/metatron/stock/stockList',
        method: 'get',
        params: query
    })
}

// 库存详情
export function stockDetail(query) {
    return request({
        url: '/methanol/metatron/stock/detailsList',
        method: 'get',
        params: query
    })
}

// 进出口量列表(首页无权限)
export function exitNoAuthList(query) {
    return request({
        url: '/methanol/metatron/exit/noAuth/exitList',
        method: 'get',
        params: query
    })
}

// 进出口量列表
export function exitPage(query) {
    return request({
        url: '/methanol/metatron/exit/exitList',
        method: 'get',
        params: query
    })
}

// 进出口量详情
export function exitDetail(query) {
    return request({
        url: '/methanol/metatron/exit/detailsList',
        method: 'get',
        params: query
    })
}

// 需求量列表(首页无权限)
export function demandNoAuthList(query) {
    return request({
        url: '/methanol/metatron/requirement/noAuth/requirementList',
        method: 'get',
        params: query
    })
}

// 需求量列表
export function demandPage(query) {
    return request({
        url: '/methanol/metatron/requirement/requirementList',
        method: 'get',
        params: query
    })
}

// 需求量详情
export function demandDetail(query) {
    return request({
        url: '/methanol/metatron/requirement/detailsRequirementList',
        method: 'get',
        params: query
    })
}

// 甲醇产业链(首页无权限)
export function chainList(query) {
    return request({
        url: '/methanol/metatron/chain/noAuth/chainPrice',
        method: 'get',
        params: query
    })
}

// 甲醇折线图
export function lineData(query) {
    return request({
        url: '/methanol/metatron/detail/lineChart',
        method: 'get',
        params: query
    })
}
